import { render, staticRenderFns } from "./TagsDropdown.vue?vue&type=template&id=ed570120&scoped=true&"
import script from "./TagsDropdown.vue?vue&type=script&lang=js&"
export * from "./TagsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TagsDropdown.vue?vue&type=style&index=0&id=ed570120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed570120",
  null
  
)

export default component.exports